const rootActionPath = 'core/CouponSearchResults';

export const COUPON_SEARCH_RESULTS_VIEW = `${rootActionPath}/VIEW`;
export const COUPON_SEARCH_RESULTS_APPLY_FILTER = `${rootActionPath}/APPLY_FILTER`;
export const COUPON_SEARCH_RESULTS_CLEAR_FILTERS = `${rootActionPath}/CLEAR_FILTER`;
